function initRoadSegmentOnMapShowing(map, id, startKm, stopKm) {
    $.get(Url.api('api/roads/map'), { roadIds: id }).then(function(roads) {
        roads.forEach(function (road) {
            addRoadSegmentLayer(map, road, startKm, stopKm);
        });
    });
}

function addRoadSegmentLayer(map, road, startKm, stopKm) {

    var coordinates = MapHelper.getCoordinatesByStartEnd(
        MapHelper.convertToLatLng(road.Coordinates),
        (startKm - road.StartKm) * 1e3,
        (stopKm - road.StartKm) * 1e3);

    var layer = L.polyline(coordinates, {
        color: road.Type.Id === 1 ? "#A52A2A" : road.Type.Id === 2 ? "#393939" : "#808080",
        weight: 11,
        smoothFactor: 1,
        opacity: .8
    });
    layer.startKm = road.StartKm;

    var text = '{Name}<br/>Код: {Code}'.format(road);
    layer.bindPopup(text, {
        id: road.Id,
        typeId: ObjectTypes.Road
    });

    map.addLayer(layer);
    layer.bringToBack();
};